export const fontFamily = "'Outfit', sans-serif"

// files in public/assets/fonts/outfit are named after these values (Outfit-<weight>.woff2/.ttf)
export const fontWeights = {
  thin: 100,
  extraLight: 200,
  light: 300,
  regular: 400,
  medium: 500,
  semiBold: 600,
  bold: 700,
  extraBold: 800,
}

export type FontWeight = keyof typeof fontWeights

export const getFontUrl = (publicUrl: string, weight: number, format: 'woff2' | 'ttf' = 'woff2') =>
  `${publicUrl}/assets/fonts/outfit/Outfit-${weight}.${format}`

export const typography = {
  fontFamily,
  fontWeights,
}
